import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Displays the SKU of the selected variant and keeps it in sync on variant changes.
 * The fallback (parent SKU) is resolved in Liquid, so the fetched section HTML is the source of truth.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSku = event.detail.data.html.querySelector(`product-sku[data-block-id="${this.dataset.blockId}"]`);

    if (!newSku) return;

    this.hidden = newSku.hidden;

    if (this.innerHTML !== newSku.innerHTML) {
      this.innerHTML = newSku.innerHTML;
    }
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
